import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function MaintenanceGate({ children }) {
  const { user } = useAuth();
  const [m, setM] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let alive = true;
    const check = () => api.get("/maintenance").then((r) => { if (alive) setM(r.data); }).catch(() => {});
    check();
    const t = setInterval(check, 60000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => { alive = false; clearInterval(t); clearInterval(tick); };
  }, []);

  if (!m?.enabled || user?.role === "admin") return children;
  const left = m.until ? Math.max(0, new Date(m.until).getTime() - now) : 0;
  const mm = String(Math.floor(left / 60000)).padStart(2, "0");
  const ss = String(Math.floor((left % 60000) / 1000)).padStart(2, "0");
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0B1E33] text-white p-6 text-center" data-testid="maintenance-screen">
      <div className="max-w-md space-y-4">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-500/15 flex items-center justify-center"><Wrench className="w-8 h-8 text-amber-400 animate-pulse" /></div>
        <h1 className="font-heading text-2xl font-bold">Sistem Sedang Di-update</h1>
        <p className="text-sm text-white/80" data-testid="maintenance-message">{m.message}</p>
        {m.until && <div className="font-mono text-3xl font-extrabold text-amber-400" data-testid="maintenance-countdown">{left > 0 ? `${mm}:${ss}` : "sebentar lagi..."}</div>}
        <p className="text-xs text-white/50">Transaksi (cetak voucher, deposit, transfer) ditangguhkan sementara. Halaman akan otomatis aktif kembali setelah update selesai.</p>
      </div>
    </div>
  );
}
